import classNames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { thumbnailsColor as thumbnailsColorSelector } from 'containers/BrandDefinition/selectors';
import { ThumbnailMap } from 'models';
import styles from '../../styles.module.scss';

type Props = {
  thumbnail: ThumbnailMap;
  allowThumbnails: boolean;
  dataTestId: string;
};

const ScreenPreview: React.FC<Props> = (props) => {
  const { thumbnail, allowThumbnails, dataTestId } = props;
  const thumbnailsColor = useSelector(thumbnailsColorSelector);
  const thumbnailUrl = thumbnail.get('url');
  const thumbnailBorder = thumbnail.get('border');
  const thumbnailName = thumbnail.get('name');
  const borderColor = thumbnailBorder ? thumbnailsColor : '';

  const isAllowThumbnails = allowThumbnails && (thumbnailName || thumbnailBorder || thumbnailUrl);

  if (!isAllowThumbnails) {
    return <div className={styles.screenPreview} data-testid={`${dataTestId}-info-preview`} />;
  }

  return (
    <div className={styles.screenThumbnailPreviewWrapper} data-testid={`${dataTestId}-info-thumbnailPreviewWrapper`}>
      <div className={styles.screenThumbnailBackground} style={{ backgroundImage: `url(${thumbnailUrl})` }}
        data-testid={`${dataTestId}-info-thumbnailPreviewWrapper-background`} />
      <div
        className={classNames(styles.screenThumbnailPreview, { [styles.border]: thumbnailBorder })}
        style={{ borderColor }}
        data-testid={`${dataTestId}-info-thumbnailPreviewWrapper-preview`}
      >
        <div style={{ color: thumbnailsColor }} className={styles.screenPreviewText}
          data-testid={`${dataTestId}-info-thumbnailPreviewWrapper-preview-text`}>
          {thumbnailName}
        </div>
      </div>
    </div>
  );
};

export default ScreenPreview;
